import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-4 sm:p-6 shadow-sm space-y-5" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_3 = { class: "grid grid-cols-7 gap-1 sm:gap-2 text-center text-[10px] sm:text-xs font-bold uppercase text-muted py-2 bg-secondary rounded-xl border border-divider" }
const _hoisted_4 = { class: "text-active" }
const _hoisted_5 = { class: "text-active" }
const _hoisted_6 = { class: "grid grid-cols-7 gap-1 sm:gap-2.5" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 md:hidden" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "font-bold text-sm text-brown" }
const _hoisted_12 = { class: "font-caudex text-base" }
const _hoisted_13 = { class: "flex items-center justify-between text-xs text-alternative-gray" }
const _hoisted_14 = { class: "text-brown" }
const _hoisted_15 = {
  key: 0,
  class: "text-xs text-success font-medium truncate"
}
const _hoisted_16 = { class: "text-[11px] text-active font-bold flex items-center justify-between pt-1 border-t border-divider/60" }
const _hoisted_17 = { class: "hidden md:block overflow-x-auto" }
const _hoisted_18 = { class: "w-full text-left text-xs border-collapse" }
const _hoisted_19 = { class: "border-b border-divider bg-secondary text-muted uppercase text-[11px]" }
const _hoisted_20 = { class: "py-3 px-3" }
const _hoisted_21 = { class: "py-3 px-3" }
const _hoisted_22 = { class: "py-3 px-3" }
const _hoisted_23 = { class: "py-3 px-3" }
const _hoisted_24 = { class: "py-3 px-3" }
const _hoisted_25 = { class: "py-3 px-3" }
const _hoisted_26 = { class: "py-3 px-3 text-right" }
const _hoisted_27 = { class: "divide-y divide-divider" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "py-3 px-3" }
const _hoisted_30 = { class: "font-bold text-brown" }
const _hoisted_31 = { class: "text-[11px] text-muted" }
const _hoisted_32 = { class: "py-3 px-3" }
const _hoisted_33 = { class: "font-bold text-sm font-caudex text-brown" }
const _hoisted_34 = { class: "text-[11px] text-muted" }
const _hoisted_35 = { class: "py-3 px-3" }
const _hoisted_36 = { class: "px-2 py-0.5 rounded text-[11px] font-bold bg-secondary text-brown" }
const _hoisted_37 = { class: "py-3 px-3" }
const _hoisted_38 = { class: "font-bold text-brown" }
const _hoisted_39 = {
  key: 0,
  class: "text-[11px] text-gold font-medium max-w-[220px] truncate"
}
const _hoisted_40 = {
  key: 1,
  class: "text-[11px] text-gold font-medium max-w-[220px] truncate"
}
const _hoisted_41 = {
  key: 2,
  class: "text-[11px] text-error font-medium max-w-[220px] truncate"
}
const _hoisted_42 = { class: "py-3 px-3" }
const _hoisted_43 = {
  key: 0,
  class: "flex flex-wrap gap-1"
}
const _hoisted_44 = {
  key: 1,
  class: "text-error text-[11px]"
}
const _hoisted_45 = { class: "py-3 px-3 font-mono text-[11px] text-brown" }
const _hoisted_46 = { class: "py-3 px-3 text-right" }
const _hoisted_47 = { class: "px-3 py-1.5 rounded-xl bg-brown text-white text-xs font-semibold inline-flex items-center gap-1" }

import { computed, ref } from "vue";
import MonthTableFiltersComponent from "@/views/Calculators/PersonalDates/components/monthReport/MonthTableFiltersComponent.vue";
import {
  BestDaysByCategory,
  FavorableMonthFilter,
  MonthDayReport,
} from "@/types/calculators";
import { useI18n } from "vue-i18n";
import EmptyDayCardComponent from "@/views/Calculators/PersonalDates/components/monthReport/EmptyDayCardComponent.vue";
import DayCardComponent from "@/views/Calculators/PersonalDates/components/monthReport/DayCardComponent.vue";
import { getWeekdayName } from "@/utils/date";
import { useLangStore } from "@/stores/langStore";
import { BADGE_TIER_CLASSES } from "@/constants/tongShu";


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthTableComponent',
  props: {
    bestDaysByCategory: {},
    days: {},
    selectedCard: {},
    isCalendarView: { type: Boolean }
  },
  emits: ["selectCard"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const { t } = useI18n();
const langStore = useLangStore();

const selectedDates = ref<string[] | null>(null);
const goldenDays = computed(() => {
  return props.days.filter((item) => item.tier === "golden");
});
const emptyCardsCount = computed(() => {
  return props.days[0].day_of_week_num - 1;
});

function handleSelectedFilter(filter: FavorableMonthFilter) {
  if (filter === "allDays") {
    selectedDates.value = null;
    return;
  }
  const filterSourceMap: Record<
    Exclude<FavorableMonthFilter, "allDays">,
    { date: string }[]
  > = {
    goldenDays: goldenDays.value,
    commerceDays: props.bestDaysByCategory.commerce.dates,
    marriageDays: props.bestDaysByCategory.marriage.dates,
    livingMoveDays: props.bestDaysByCategory.living_move.dates,
    careerDays: props.bestDaysByCategory.career.dates,
    travelDays: props.bestDaysByCategory.travel.dates,
    medicalDays: props.bestDaysByCategory.medical.dates,
  };
  const targetArray = filterSourceMap[filter];

  selectedDates.value = targetArray.map((item) => item.date);
}

function formatHourRange(rangeStr: string): string {
  if (!rangeStr) return "";

  const startTime = rangeStr.split("-")[0].trim();
  return `(${startTime})`;
}

function getBestHoursString(dayReport: MonthDayReport): string {
  const bestHours = dayReport.best_hours || [];

  return bestHours
    .map((h) => `${h.branch}时 ${formatHourRange(h.time_std)}`)
    .join(", ");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MonthTableFiltersComponent, {
      allDays: __props.days.length,
      goldenDays: goldenDays.value.length,
      commerceDays: __props.bestDaysByCategory.commerce.dates.length,
      marriageDays: __props.bestDaysByCategory.marriage.dates.length,
      livingMoveDays: __props.bestDaysByCategory.living_move.dates.length,
      careerDays: __props.bestDaysByCategory.career.dates.length,
      travelDays: __props.bestDaysByCategory.travel.dates.length,
      medicalDays: __props.bestDaysByCategory.medical.dates.length,
      onSelectFilter: handleSelectedFilter
    }, null, 8, ["allDays", "goldenDays", "commerceDays", "marriageDays", "livingMoveDays", "careerDays", "travelDays", "medicalDays"]),
    (__props.isCalendarView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)("week-names.monday")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)("week-names.tuesday")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)("week-names.wednesday")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)("week-names.thursday")), 1),
            _createElementVNode("div", null, _toDisplayString(_unref(t)("week-names.friday")), 1),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("week-names.saturday")), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("week-names.sunday")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emptyCardsCount.value, (index) => {
              return (_openBlock(), _createBlock(EmptyDayCardComponent, { key: index }))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (dayReport, index) => {
              return (_openBlock(), _createBlock(DayCardComponent, {
                key: dayReport.date,
                dayReport: dayReport,
                cardNumber: index + 1,
                isCardSelected: 
            __props.selectedCard !== null && __props.selectedCard.date === dayReport.date
          ,
                isCardMuted: 
            selectedDates.value !== null && !selectedDates.value.includes(dayReport.date)
          ,
                onClick: ($event: any) => (emits('selectCard', dayReport))
              }, null, 8, ["dayReport", "cardNumber", "isCardSelected", "isCardMuted", "onClick"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (dayReport) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-3.5 rounded-xl border transition-all cursor-pointer space-y-2 bg-[#FFFDF7] border-gold/60",
                key: dayReport.date,
                onClick: ($event: any) => (emits('selectCard', dayReport, true))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(_toDisplayString(dayReport.date.split("-").reverse().join(".")) + " (" + _toDisplayString(_unref(getWeekdayName)(dayReport.date, _unref(langStore).current, "short")) + ") • ", 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(dayReport.pillars.day), 1)
                  ]),
                  _createElementVNode("span", {
                    class: _normalizeClass(["px-2 py-0.5 rounded-full text-[10px] font-bold bg-gold text-white", _unref(BADGE_TIER_CLASSES)[dayReport.tier]])
                  }, _toDisplayString(_unref(t)(`calculators.personal-date.card-barge.${dayReport.tier}`)) + " (" + _toDisplayString(dayReport.combined_index) + "%) ", 3)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.card-barge.month-table.officer")) + " ", 1),
                    _createElementVNode("strong", _hoisted_14, _toDisplayString(dayReport.officer_12.name) + " (" + _toDisplayString(dayReport.officer_12.title_ua) + ") ", 1)
                  ]),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("calculators.personal-date.top-days.rang")) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(dayReport.general_status.rank_code), 1)
                  ])
                ]),
                (dayReport.yi_preview.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 宜: " + _toDisplayString(dayReport.yi_preview.slice(0, 3).join(", ")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.hours")) + " " + _toDisplayString(getBestHoursString(dayReport)), 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.personal-date.month-table.openDay")) + " → ", 1)
                ])
              ], 8, _hoisted_9))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", _hoisted_18, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_19, [
                  _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("calculators.personal-date.month-table.columns.date")), 1),
                  _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t(
                    "calculators.personal-date.month-table.columns.pillarManager"
                  )), 1),
                  _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t(
                    "calculators.personal-date.month-table.columns.generalRank"
                  )), 1),
                  _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t(
                    "calculators.personal-date.month-table.columns.baziResonance"
                  )), 1),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t(
                    "calculators.personal-date.month-table.columns.recommendedActivities"
                  )), 1),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("calculators.personal-date.month-table.columns.bestHours")), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t("calculators.personal-date.month-table.columns.action")), 1)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.days, (dayReport) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(["hover:bg-hover transition-colors cursor-pointer", dayReport.tier === 'golden' ? 'bg-[#FFFDF9]' : '']),
                    key: dayReport.date,
                    onClick: ($event: any) => (emits('selectCard', dayReport, true))
                  }, [
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(dayReport.date.split("-").reverse().join(".")) + " (" + _toDisplayString(_unref(getWeekdayName)(dayReport.date, _unref(langStore).current, "short")) + ") ", 1),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("calculators.personal-date.month-table.monthly")) + " " + _toDisplayString(dayReport.lunar_short), 1)
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, _toDisplayString(dayReport.pillars.day) + " (" + _toDisplayString(dayReport.day_animal) + ") ", 1),
                      _createElementVNode("div", _hoisted_34, _toDisplayString(dayReport.officer_12.name) + " - " + _toDisplayString(dayReport.officer_12.title_ua), 1)
                    ]),
                    _createElementVNode("td", _hoisted_35, [
                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.$t("calculators.personal-date.top-days.rang")) + " " + _toDisplayString(dayReport.general_status.rank_code), 1)
                    ]),
                    _createElementVNode("td", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, _toDisplayString(dayReport.personal_status.score) + "% (" + _toDisplayString(dayReport.personal_status.ten_god_stem) + ") ", 1),
                      (dayReport.personal_status.structures.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(dayReport.personal_status.structures[0]), 1))
                        : _createCommentVNode("", true),
                      (dayReport.personal_status.stars.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(dayReport.personal_status.stars[0]), 1))
                        : _createCommentVNode("", true),
                      (dayReport.personal_status.warnings.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(dayReport.personal_status.warnings[0]), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_42, [
                      (dayReport.yi_preview.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dayReport.yi_preview.slice(0, 3), (yiDoing, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                class: "px-1.5 py-0.5 bg-white border border-divider rounded text-[11px]",
                                key: index
                              }, _toDisplayString(yiDoing.name) + " (" + _toDisplayString(yiDoing.ua) + ") ", 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_44, " 诸事不宜 (" + _toDisplayString(_ctx.$t("calculators.personal-date.month-table.routineOnly")) + ") ", 1))
                    ]),
                    _createElementVNode("td", _hoisted_45, _toDisplayString(getBestHoursString(dayReport)), 1),
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("calculators.personal-date.month-table.showDetailed")), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("span", null, "→", -1))
                      ])
                    ])
                  ], 10, _hoisted_28))
                }), 128))
              ])
            ])
          ])
        ]))
  ]))
}
}

})